import React from "react";
import { MDBCol, MDBRow } from "mdbreact";
import TableComponent from "../../../SharedComponents/Table";
import { grandTitleConfig } from "./Config";
import * as Constants from "../../../../constants/constants";
import ClearTrackService from "../../../../services/service";
import { CircularProgress } from "@material-ui/core";
import { withUserContext } from '../../../../contexts/UserContext';
import '../LookupMaintenance.scss';
import { updateTableSortConfigObject, tableSortList } from '../../../../Common/TableHelper';
import MessageModal from '../../../SharedComponents/MessageModal';

class GrandTitle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      renderList: [],
      config: { ...grandTitleConfig },
      grandTitleNotExist: false,
      sortBy: "Value",
      isSortByAsc: true,
      sortCount: 0,
      duplicateValue:false,
    };
  }

  componentDidMount() {
    this.getGrandTitleDetails();
    
  }

  getGrandTitleDetails = (loader=true) => {
    this.setState({ isLoading: loader });
    ClearTrackService.getData(
      Constants.ClearTrackServiceBaseUrl + "/staticData?staticTable=lu_grand_title",
      this.props?.userContext?.active_tenant?.tenant_id
    )
      .then((response) => {
        console.log("response in getGrandTitleDetails", response);
        let useList = response?.data?.map((item) => ({
          name: item.name,
          id: item.id,
          is_active: item.is_active,
        }));
        let configRecord = {...this.state.config}
        configRecord.actions = [ ];
        if(this.props?.permissionArray[0].edit === 1){
          configRecord.actions.push("pen");
        }
        if(this.props?.permissionArray[0].delete === 1){
          configRecord.actions.push("times");
        }
        this.setState({ renderList: useList, config: configRecord, isLoading: false,isSubmit: false });
        this.handleTableColumnClick("Grand Title");
      })
      .catch((err) => {
        console.log("error", err);
        this.setState({ isLoading: false, isSubmit: false });
      });
  };

  handleInlineEdits = (id, dataItem) => {
    let allDetails = [...this.state.renderList];
    this.setState({
      isLoading : false,
      isSubmit:false,
      grandTitleNotExist: false,
      renderList: allDetails.map((item) => {
        let newItem = {...item}
        if (item.id == id) newItem["editing"] = true;
        return newItem;
      }),
    });
  };

  saveInlineEdits = (data, index, pkValue, dataItem) => {
    this.setState({ grandTitleNotExist: false,isSubmit:false,isLoading : false ,duplicateValue: false}, () => {
      if (data[index]?.name && data[index]?.name?.length > 0) {
        if(!this.state?.renderList?.some((item,i)=>item?.name?.toLowerCase() ==  data[index]?.name?.toLowerCase() && index != i)) {
        let allDetails = [...this.state.renderList];
        let dataList = [...data];
        allDetails[index].is_active = dataList[index].is_active ? 1 : 0;
        allDetails[index].name = dataList[index].name;
        this.postGrandTitleDetails(allDetails[index], allDetails[index]?.id);
        } else {
          this.setState({ duplicateValue: true })
        }
      } else {
        this.setState({ grandTitleNotExist: true })
      }
    })
  };

  handleAddNewItem = (newDataItem) => {
    this.setState({ grandTitleNotExist: false,isSubmit:false , duplicateValue: false}, () => {
      if (newDataItem?.name && newDataItem?.name?.length > 0) {
        if(!this.state?.renderList?.some((item,i)=>item?.name?.toLowerCase() == newDataItem?.name?.toLowerCase())) {
          let grandTitleData = {
            ...newDataItem,
            is_active: 1,
            name: newDataItem?.name,
          };
         this.postGrandTitleDetails(grandTitleData,"newItemPost");
        } else {
          this.setState({ duplicateValue: true })
        }
      } else {
        this.setState({ grandTitleNotExist: true })
      }
    })
    
  };

  postGrandTitleDetails = (grandTitleDetails, postFlag) => {
    grandTitleDetails.table_name = "lu_grand_title";
    this.setState({ isSubmit: postFlag, grandTitleNotExist: false });
    ClearTrackService.postDataParams(
      Constants.ClearTrackServiceBaseUrl + `/staticData`,
      grandTitleDetails,
      this.props?.userContext?.active_tenant?.tenant_id
    ).then(
      (response) => {
        if (response.data.error) {
          this.props.toastMessageNotification(true, "fail");
          this.getGrandTitleDetails();
        } else {
          if (grandTitleDetails?.editing === true) {
            grandTitleDetails.editing = false;
          }
           this.setState({ isSubmit: false });
          this.props.toastMessageNotification(true, "success");
          this.getGrandTitleDetails(false);
        }
      },
      (err) => {
        this.setState({ isSubmit: false });
        this.props.toastMessageNotification(true, "fail");
      }
    );
  };

  handleTableColumnClick = (column) => {
    if (column === this.state.sortBy) {
      this.setState({ sortCount: this.state.sortCount + 1 }, () => {
        this.handleTableSort(column);
      })
    }
    else this.setState({ sortCount: 0 }, () => {
      this.handleTableSort(column);
    })
  }

  handleTableSort = (colName) => {
    this.setState({
      isSortByAsc: this.state.sortCount % 2 === 0 ? true : false,
      config: updateTableSortConfigObject(this.state.config, this.state.isSortByAsc, this.state.sortBy, colName)
    }, () => {
      this.setState({
        sortBy: colName,
        renderList: tableSortList("Name", this.getSortNode(colName), this.state.renderList, this.state.isSortByAsc)
      });
    })
  }

  getSortNode = (col) => {
    switch (col) {
      case "Grand Title": return "name";
    }
  }
  deleteGrandTitle = (grandTitleData) => {
      this.setState({ isSubmit: true })
      ClearTrackService.getData(
        Constants.ClearTrackServiceBaseUrl + `/checkRelationalTables?tableName=lu_grand_title&tableId=${grandTitleData?.id}`,
        this.props?.userContext?.active_tenant?.tenant_id
      ).then(res => {
        if (res.data[0].status === "SUCCESS") {
          let grandTitlePayload = {
              ...grandTitleData,
              is_delete: 1
            }
            this.openDeleteModal(grandTitleData, grandTitlePayload);
          //this.postGrandTitleDetails(grandTitlePayload, grandTitleData?.id)
        } else {
          this.props?.fieldChanged(true, 'fail')
          this.setState({ isSubmit: false });
        }
      }),
        ((err) => {
          this.props?.fieldChanged(true)
          this.setState({ isSubmit: false });
        });
    };

  openDeleteModal = (grandTitleData,grandTitlePayloadToDelete) => {
    this.setState({openInlineDeleteModal: true, grandTitleData: grandTitleData, grandTitlePayloadToDelete})
  }
  onConfirmDelete = () => {
    const { grandTitleData, grandTitlePayloadToDelete } = this.state;
    this.postGrandTitleDetails(grandTitlePayloadToDelete, grandTitleData?.id);
    this.setState({ openInlineDeleteModal: false });
  };

  render() {
    let permissionValue = this.props?.permissionArray;
    return (
      <div className="grandTitle-Container">
        <MDBRow className="pd">
        <span className="errorText">{this.state.grandTitleNotExist && 'Please enter Grand Title field value'}</span>
        <span className="errorText">{this.state.duplicateValue && 'Grand Title value already exist'}</span>
        </MDBRow>
        {this.state.isLoading ? (
          <CircularProgress size={24} />
        ) : (
          <>
            <MDBRow>
              <MDBCol md={4} id="grandTitle-table-bg-sync-efc">
                <TableComponent
                  list={this.state.renderList || []}
                  className={"clearencRecord"}
                  handleAddNewItem={this.handleAddNewItem.bind(this)}
                  config={this.state.config}
                  editCallback={this.handleInlineEdits.bind(this)}
                  saveCallback={this.saveInlineEdits.bind(this)}
                  addItemToList={true}
                  stickyHeader={true}
                  newIsActive={true}
                  // isLoading={this.state.isSubmit}
                  postInitiated={this.state.isSubmit}
                  readCallback={(index) => {
                    let grandRightOptions = [...this.state.renderList];
                    grandRightOptions[index].editing = false
                    this.setState({ renderList: grandRightOptions, grandTitleNotExist: false });
                  }}
                  sortCallback={this.handleTableColumnClick}
                  handleDelCallBack={(id, item) => this.deleteGrandTitle(item)}
                />
              </MDBCol>
            </MDBRow>
            {this.state.openInlineDeleteModal &&
              <MessageModal
                  style={{ width: '420px'}}
                  open={this.state.openInlineDeleteModal || false}
                  title={"Delete Grand Title"}
                  message={`Do you want to delete the selected grand title ?`}
                  hideCancel={false}
                  primaryButtonText={"OK"}
                  secondaryButtonText={"Cancel"}
                  onConfirm={this.onConfirmDelete}
                  handleClose={() =>this.setState({openInlineDeleteModal: false})} />
            }
          </>
          )}
      </div>
    );
  }
}

export default withUserContext(GrandTitle);